module.exports = __webpack_public_path__ + "static/media/AeroGCS-Inactive.d1d0d3ee.svg";